import { createContext } from 'react';
import { RootStore } from './rootStore';

export const RootStoreContext = createContext<RootStore | undefined>(undefined);

RootStoreContext.displayName = 'RootStoreContext'
